import { returnSign } from 'helpers/helpers'

/** Разбор `order_by` из API: строка вида `name,asc` / `sale_price,desc`. */
export function parseProductTableOrderBy(orderByStr) {
	if (!orderByStr || typeof orderByStr !== "string") return { field: null, sort: "asc" }
	const parts = orderByStr.split(",")
	const field = (parts[0] || "").trim() || null
	const sort = (parts[1] || "asc").trim().toLowerCase() === "desc" ? "desc" : "asc"
	return { field, sort }
}

/** Сборка значения `order_by` для query (как в старом селекте columnOrders). */
export function buildProductTableOrderBy(field, sort) {
	if (!field) return null
	return `${field},${sort === "desc" ? "desc" : "asc"}`
}

/** Единая сборка query для /products (таблица, Excel, ингредиенты). */
export function buildFilterParams(filterDataCopy = {}) {
	var urlParams = ""

	if (filterDataCopy.pos_id)
		urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
	if (filterDataCopy.wms_id)
		urlParams += returnSign(urlParams) + 'wms_id=' + filterDataCopy.wms_id
	if (filterDataCopy.order_by)
		urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
	if (filterDataCopy.status != null && filterDataCopy.status !== '')
		urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
	if (filterDataCopy.product_without)
		urlParams += returnSign(urlParams) + 'product_without=' + filterDataCopy.product_without
	if (filterDataCopy.category_id)
		urlParams += returnSign(urlParams) + 'category_id=' + filterDataCopy.category_id
	if (filterDataCopy.menu_ids && filterDataCopy.menu_ids.length > 0) {
		const ids = filterDataCopy.menu_ids.map(item => item.id).join(',')
		urlParams += returnSign(urlParams) + 'menu_ids=' + ids
	}
	if (filterDataCopy.preparation_place_id)
		urlParams += returnSign(urlParams) + 'preparation_place_id=' + filterDataCopy.preparation_place_id
	if (filterDataCopy.menu_id)
		urlParams += returnSign(urlParams) + 'menu_id=' + filterDataCopy.menu_id
	if (filterDataCopy.product_type_id != null && filterDataCopy.product_type_id !== '')
		urlParams += returnSign(urlParams) + 'product_type_id=' + filterDataCopy.product_type_id
	if (filterDataCopy.from_profit_percent)
		urlParams += returnSign(urlParams) + 'from_profit_percent=' + filterDataCopy.from_profit_percent
	if (filterDataCopy.to_profit_percent)
		urlParams += returnSign(urlParams) + 'to_profit_percent=' + filterDataCopy.to_profit_percent
	if (filterDataCopy.search)
		urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
	if (filterDataCopy.size)
		urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
	if (filterDataCopy.page)
		urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

	return urlParams
}
